import { useMemeEditor } from "../MemeEditorContext";
import { PreviewContent } from "./PreviewContent/PreviewContent";

export const ShadowPreview = () => {
    const { shadowParentContainerRef } = useMemeEditor();
    return (
        <div className="fixed left-0 top-0 -z-50 text-black dark:text-black">
            <div className="relative inline-block" ref={shadowParentContainerRef}>
                <PreviewContent />
            </div>
        </div>
    );
};
